import { useContext } from "react";
import useApi from "../hooks/useApi";
import { HotelContext } from "../context/hotel";
import { CheckInContext } from "../context/checkin";


const useBookableItems = () => {
    const { get, patch } = useApi();
    const { data } = useContext(HotelContext);
    const { data: checkIn } = useContext(CheckInContext);


    const getBookableList = async () => {
        try {
            const response = await get(`hotels/${data.id}/bookables`);
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };

    const getBookableItem = async (itemId) => {
        try {
            const response = await get(`hotels/${data.id}/bookables/${itemId}`);
            return response;

        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };

    const getSchedule = async (itemId) => {
        try {
            const response = await get(`hotels/${data.id}/bookables/${itemId}/schedule?checkin_start=${checkIn.dateStart}&checkin_end=${checkIn.dateEnd}`);
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };

    const getScheduleCustom = async (itemId, dateStart, dateEnd, isPublic = null) => {
        try {
            let url = `hotels/${data.id}/bookables/${itemId}/schedule?checkin_start=${dateStart}&checkin_end=${dateEnd}`;
            if (isPublic) {
                url = url + '&public=1';
            }
            const response = await get(url);
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };

    const getBookableReservation = async (bookableReservationId) => {
        try {
            const response = await get(`hotels/${data.id}/public/reservations/${bookableReservationId}`);
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };

    const confirmBookableReservation = async (bookableReservationId) => {
        try {
            const response = await patch(`hotels/${data.id}/public/reservations/${bookableReservationId}`, { confirmed: 1 });
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };

    const cancelRequest = async (requestId) => {
        try {
            const response = await patch(`hotels/${data.id}/public/requests/${requestId}/cancel`);
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };


    return {
        getBookableList,
        getBookableItem,
        getSchedule,
        getScheduleCustom,
        getBookableReservation,
        confirmBookableReservation,
        cancelRequest
    };
};

export default useBookableItems;
